import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { UntypedFormGroup, UntypedFormControl, Validators, FormArray } from '@angular/forms';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { MessageBoxComponent } from '../../../common/message-box/message-box.component';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { DeleteBoxComponent } from '../../../common/delete-box/delete-box.component';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-add-product-approval',
  templateUrl: './add-product-approval.component.html',
  styleUrls: ['./add-product-approval.component.scss']
})
export class AddProductApprovalComponent implements OnInit {

  @Input() public Content: any;
  formFields;
  countryList: any[];
  ApprovalTypeList: any[] = [{ "value": "1", "label": "Investigational Drug" }, { "value": "2", "label": "Marketed Drug" }];
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  addProductApprovalViewForm: UntypedFormGroup;
  CountryAuthorizationsForm: UntypedFormGroup;
  NDCDINForm: UntypedFormGroup;
  NDCDINList = [];
  CountryAuthorization = [];
  constructor(
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    public datepipe: DatePipe,
    private commonService: CommonService
  ) {
  }
  ngOnInit() {
    this.addProductApprovalViewForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      PRODUCT_ID: new UntypedFormControl(""),
      TRADE_NAME: new UntypedFormControl("", [Validators.required]),
      AUTHORIZATION_HOLDER: new UntypedFormControl("", [Validators.required]),
      APPROVAL_TYPE: new UntypedFormControl(""),
      APPROVAL_NO: new UntypedFormControl("", [Validators.required]),

    });
    const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
    this.CountryAuthorizationsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      PRODUCT_ID: new UntypedFormControl(""),
      PRODUCT_APPROVAL_ID: new UntypedFormControl(""),
      COUNTRY: new UntypedFormControl("", [Validators.required]),
      WEB_SITE: new UntypedFormControl("", [Validators.required, Validators.pattern(reg)]),
      CONTACT_NO: new UntypedFormControl("", [Validators.required]),
      AWARD_DATE: new UntypedFormControl(null),
      WITHDRAWN_DATE: new UntypedFormControl(null),
      IS_ALLOW_SHIPMENT: new UntypedFormControl(false),
      IS_ALLOW_AUTHORISED: new UntypedFormControl(false)
    });
    this.NDCDINForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      PRODUCT_ID: new UntypedFormControl(""),
      PRODUCT_APPROVAL_ID: new UntypedFormControl(""),
      COUNTRY_AUTH_ID: new UntypedFormControl(""),
      DESCRIPTION: new UntypedFormControl(""),
      NDC_NO: new UntypedFormControl("", [Validators.required]),
    });
    if (this.Content.heading == "View") {
      this.GetEditData();
      this.addProductApprovalViewForm.disable();
      this.NDCDINForm.disable();
      this.CountryAuthorizationsForm.disable();
    }
    if (this.Content.heading == "Edit") {
      this.GetEditData();
    }
    this.GetMasterData();
  }
  GetMasterData() {
    this.countryList = [];
    this.summaryService.GetMasterScreenData("api/Product/GetMasterScreenData?RecordID=" + this.Content.content.id).subscribe(summary => {
      this.countryList = summary["MasterData3"];
    });
  }
  GetEditData(): void {

    this.summaryService.getRecord('api/Product/GetApprovalRecord?ApprovalID=' + this.Content.content.id).subscribe(summary => {
      this.NDCDINList = [];
      this.CountryAuthorization = [];
      this.addProductApprovalViewForm.patchValue({
        ID: summary["ID"],
        PRODUCT_ID: summary["PRODUCT_ID"],
        TRADE_NAME: summary["TRADE_NAME"],
        AUTHORIZATION_HOLDER: summary["AUTHORIZATION_HOLDER"],
        APPROVAL_TYPE: summary["APPROVAL_TYPE"],
        APPROVAL_NO: summary["APPROVAL_NO"],
      });
      summary["CountryAuthDetails"].forEach((item, index) => {
        var formData = item;
        formData["TRADE_NAME"] = summary["TRADE_NAME"];
        formData["CountryName"] = "";
        var data = this.countryList.filter(x => x.value == formData["COUNTRY"])[0];
        if (data != null && data != undefined) {
          formData["CountryName"] = data.label;
        }
        formData["NDCNumber"] = "";
        if (item["NDCDINList"] != undefined && item["NDCDINList"] != null) {
          item["NDCDINList"].forEach((item1, index1) => {
            if (index1 === 0) {
              formData["NDCNumber"] = item1["NDC_NO"];
            }
            else {
              formData["NDCNumber"] = formData["NDCNumber"] + ", " + item1["NDC_NO"];
            }
          });
        }
      });
      this.CountryAuthorization = summary["CountryAuthDetails"];

    });
  }
  EditCountry(item) {
    //debugger;
    if (item != null && item != undefined) {
      if (item["AWARD_DATE"] != null && item["AWARD_DATE"] != undefined) {
        item["AWARD_DATE"] = this.datepipe.transform(item["AWARD_DATE"], 'dd-MMM-yyyy');
      }
      if (item["WITHDRAWN_DATE"] != null && item["WITHDRAWN_DATE"] != undefined) {
        item["WITHDRAWN_DATE"] = this.datepipe.transform(item["WITHDRAWN_DATE"], 'dd-MMM-yyyy');
      }
    }
    this.CountryAuthorizationsForm.patchValue(item);
    this.NDCDINList = item.NDCDINList;
  }
  DeleteCountry(item) {
    if (item != undefined && item.length < 10) {
      let modalRef = this.modalService.open(DeleteBoxComponent,{backdrop: false});
      modalRef.result.then(result => {
        this.CountryAuthorization = this.CountryAuthorization.filter(item1 => {
          return item1.ID != item;
        });
      });

    }
    else {
      let modalRef = this.modalService.open(DeleteBoxComponent,{backdrop: false});
        modalRef.result.then(result => {
        this.summaryService.Delete('api/Product/DeleteAuthCountry?AuthID=' + item).subscribe(summary => {
          //debugger;
          if (summary["Status"] == 0) {
            this.commonService.SuccessBanner("Selected Record(s) has been Deleted");
            let code = item;
            this.CountryAuthorization = this.CountryAuthorization.filter(function (sec) {
              return sec.ID != code;
            }, code);
          }
          else {
            this.commonService.ValidationBanner("Error Occured while deleting");

          }
        });
      })
    }

  }
  SaveProductDetails() {
    //debugger;
    if (this.validateControls() && (this.CountryAuthorization.length > 0 || this.CountryAuthorizationsForm.valid)) {
      //debugger;
      this.AddCountryAuth();
      var formDataParent = this.addProductApprovalViewForm.value;
      formDataParent["CountryAuthDetails"] = [];
      formDataParent["CountryAuthDetails"] = this.CountryAuthorization;
      this.CountryAuthorization.forEach((item, index) => {
        if (item["AWARD_DATE"] != null && item["AWARD_DATE"] != undefined) {
          const ldate = new Date(item["AWARD_DATE"]);
          item["STR_AWARD_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
        }
        if (item["WITHDRAWN_DATE"] != null && item["WITHDRAWN_DATE"] != undefined) {
          const ldate = new Date(item["WITHDRAWN_DATE"]);
          item["STR_WITHDRAWN_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
        }
      });

      formDataParent["PRODUCT_ID"] = this.content.id;
      if (this.heading == "Add") {
        this.summaryService.Insert('api/Product/SaveProductAPprovals', formDataParent).subscribe(summary => {
          this.commonService.SuccessBanner("Data has been inserted successfully");
//          this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });

          this.modalRef.close();
        });
      } else {
        this.summaryService.Insert('api/Product/UpdateProductAPprovals', formDataParent).subscribe(summary => {
          this.commonService.SuccessBanner("Data has been updated successfully");
//          this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });

          this.modalRef.close();
        });
      }
    }
  }


  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.addProductApprovalViewForm.value;
    if (formData.TRADE_NAME === null || formData.TRADE_NAME === "" || formData.TRADE_NAME === undefined) {
      $("#TRADE_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#TRADE_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Trade Name<br/>";
      isValid = false;
    } else {
      $("#TRADE_NAME").addClass("ng-untouched ng-valid");
      $("#TRADE_NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.AUTHORIZATION_HOLDER === null || formData.AUTHORIZATION_HOLDER === "" || formData.AUTHORIZATION_HOLDER === undefined) {
      $("#AUTHORIZATION_HOLDER").addClass("ng-touched ng-invalid validate-error");
      $("#AUTHORIZATION_HOLDER").removeClass("ng-untouched ng-valid");
      message += "Please enter Authorization Holder<br/>";
      isValid = false;
    } else {
      $("#AUTHORIZATION_HOLDER").addClass("ng-untouched ng-valid");
      $("#AUTHORIZATION_HOLDER").removeClass("ng-touched ng-invalid validate-error");
    }
    if (formData.APPROVAL_NO === null || formData.APPROVAL_NO === "" || formData.APPROVAL_NO === undefined) {
      $("#APPROVAL_NO").addClass("ng-touched ng-invalid validate-error");
      $("#APPROVAL_NO").removeClass("ng-untouched ng-valid");
      message += "Please enter Approval No<br/>";
      isValid = false;
    } else {
      $("#APPROVAL_NO").addClass("ng-untouched ng-valid");
      $("#APPROVAL_NO").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
    this.commonService.ValidationBanner(message);
//      this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    return isValid;
  }

  AddCountryAuth() {
    debugger;
    if (this.CountryAuthValidations() && (this.NDCDINList.length > 0 || this.NDCDINForm.valid) ) {
      var formDate = this.CountryAuthorizationsForm.value;
      formDate["TRADE_NAME"] = this.addProductApprovalViewForm.controls["TRADE_NAME"].value;

      if (formDate["AWARD_DATE"] != null && formDate["AWARD_DATE"] != undefined) {
        formDate["AWARD_DATE"] = new Date(formDate["AWARD_DATE"]);
      }
      if (formDate["WITHDRAWN_DATE"] != null && formDate["WITHDRAWN_DATE"] != undefined) {
        formDate["WITHDRAWN_DATE"] = new Date(formDate["WITHDRAWN_DATE"]);
      }
      formDate["CountryName"] = "";
      var data = this.countryList.filter(x => x.value == this.CountryAuthorizationsForm.controls["COUNTRY"].value)[0];
      if (data != null && data != undefined) {
        formDate["CountryName"] = data.label;

      }

      if (this.NDCDINForm.valid) {
        var formDateChild = this.NDCDINForm.value;
        this.NDCDINList.push(formDateChild);
        this.NDCDINForm.reset();
      }
      var data1 = "";
      formDate["NDCNumber"] = "";
      this.NDCDINList.forEach((item, index) => {
        if (index === 0) {
          formDate["NDCNumber"] = item["NDC_NO"];
          data1 = data1 + formDate["NDCNumber"] + "|" + item["DESCRIPTION"];
        }
        else {
          formDate["NDCNumber"] = formDate["NDCNumber"] + ", " + item["NDC_NO"];
          data1 = data1 +", "+ formDate["NDCNumber"] + "|" + item["DESCRIPTION"];
        }

      });
      formDate["NDCDINListValues"] = data1;
      formDate["NDCDINList"] = [];
      formDate["NDCDINList"] = this.NDCDINList;
      if (this.CountryAuthorization != undefined && this.CountryAuthorization.length == 0) {
        this.CountryAuthorization.push(formDate);
      }
      this.CountryAuthorization.forEach((item1, index1) => {
        if (formDate["ID"] == item1.ID) {

          item1["TRADE_NAME"] = formDate["TRADE_NAME"];
          item1["AWARD_DATE"] = formDate["AWARD_DATE"];
          item1["WITHDRAWN_DATE"] = formDate["WITHDRAWN_DATE"];
          item1["NDCDINList"] = formDate["NDCDINList"];
          item1["NDCDINListValues"] = formDate["NDCDINListValues"];
          item1["NDCDINList"] = formDate["NDCDINList"];
          item1["NDCNumber"] = formDate["NDCNumber"];
          item1["CountryName"] = formDate["CountryName"];
          item1["COUNTRY"] = formDate["COUNTRY"];
          item1["WEB_SITE"] = formDate["WEB_SITE"];
          item1["CONTACT_NO"] = formDate["CONTACT_NO"];
          item1["IS_ALLOW_SHIPMENT"] = formDate["IS_ALLOW_SHIPMENT"];
          item1["IS_ALLOW_AUTHORISED"] = formDate["IS_ALLOW_AUTHORISED"];

        }
        else  {
          this.CountryAuthorization.push(formDate);
        }
      });

      this.CountryAuthorizationsForm.reset();
      this.NDCDINList = [];
    }

  }

  CountryAuthValidations(): boolean {
    let isValid = true;
    let message = "";
    if (this.CountryAuthorizationsForm.valid) {
      const formData = this.CountryAuthorizationsForm.value;
      if (formData.COUNTRY === null || formData.COUNTRY === "" || formData.COUNTRY === undefined) {
        $("#COUNTRY").addClass("ng-touched ng-invalid validate-error");
        $("#COUNTRY").removeClass("ng-untouched ng-valid");
        message += "Please select COUNTRY<br/>";
        isValid = false;
      } else {
        $("#COUNTRY").addClass("ng-untouched ng-valid");
        $("#COUNTRY").removeClass("ng-touched ng-invalid validate-error");
      }
      if (formData.WEB_SITE === null || formData.WEB_SITE === "" || formData.WEB_SITE === undefined) {
        $("#WEB_SITE").addClass("ng-touched ng-invalid validate-error");
        $("#WEB_SITE").removeClass("ng-untouched ng-valid");
        message += "Please select Web site<br/>";
        isValid = false;
      } else {
        const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
        if (formData.WEB_SITE.match(reg)) {
          $("#WEB_SITE").addClass("ng-untouched ng-valid");
          $("#WEB_SITE").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#WEB_SITE").addClass("ng-touched ng-invalid validate-error");
          $("#WEB_SITE").removeClass("ng-untouched ng-valid");
          message += "Please enter Valid Web site<br/>";
          isValid = false;
        }
      }
      if (formData.CONTACT_NO === null || formData.CONTACT_NO === "" || formData.CONTACT_NO === undefined) {
        $("#CONTACT_NO").addClass("ng-touched ng-invalid validate-error");
        $("#CONTACT_NO").removeClass("ng-untouched ng-valid");
        message += "Please enter Contact No<br/>";
        isValid = false;
      } else {
        const phoneformat = /^[1-9]\d*$/;
        formData.CONTACT_NO = formData.CONTACT_NO + "";
        if (formData.CONTACT_NO.match(phoneformat)) {
          $("#CONTACT_NO").addClass("ng-untouched ng-valid");
          $("#CONTACT_NO").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#CONTACT_NO").addClass("ng-touched ng-invalid validate-error");
          $("#CONTACT_NO").removeClass("ng-untouched ng-valid");
          message += "Please enter Valid Contact No<br/>";
          isValid = false;
        }
      }
      if (!isValid)
      this.commonService.ValidationBanner(message);
//        this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });

    }
       return isValid;
  }
  AddNDCDIN() {
    debugger;
    if (this.ValidateNDNC()) {
      var formDate = this.NDCDINForm.value;
      if (formDate["ID"] == "") {
        formDate["ID"] = ((this.NDCDINList.length) + 1) + "";
      }
      formDate["CountryName"] = "";
      var data = this.countryList.filter(x => x.value == this.NDCDINForm.controls["DESCRIPTION"].value)[0];
      if (data != null && data != undefined) {
        formDate["CountryName"] = data.label;
      }

      this.NDCDINList.push(formDate);
      this.NDCDINForm.reset();
    }

  }
  ValidateNDNC(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.NDCDINForm.value;
    if (formData.NDC_NO === null || formData.NDC_NO === "" || formData.NDC_NO === undefined) {
      $("#NDC_NO").addClass("ng-touched ng-invalid validate-error");
      $("#NDC_NO").removeClass("ng-untouched ng-valid");
      message += "Please enter NDC_NO<br/>";
      isValid = false;
    } else {
      $("#NDC_NO").addClass("ng-untouched ng-valid");
      $("#NDC_NO").removeClass("ng-touched ng-invalid validate-error");
    }
    if (!isValid)
    this.commonService.ValidationBanner(message);
//      this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    return isValid;
  }
  DeleteNDC(id) {
    debugger;
    if (id != undefined && id.length < 10) {
      let modalRef = this.modalService.open(DeleteBoxComponent,{backdrop: false});
      modalRef.result.then(result => {
        var filterData = this.NDCDINList.filter(item => {
          return item.ID != id;
        });
        this.NDCDINList = [];
        this.NDCDINList = filterData;
      });

    }
    else {
      let modalRef = this.modalService.open(DeleteBoxComponent,{backdrop: false});
      modalRef.result.then(result => {
        this.summaryService.Delete('api/Product/DeleteAuthCountryNDC?NDCID=' + id).subscribe(summary => {
          debugger;
          if (summary["Status"] == 0) {
            this.commonService.SuccessBanner("Selected Record(s) has been Deleted");
            let code = id;
            this.CountryAuthorization = this.CountryAuthorization.filter(function (sec) {
              return sec.ID != code;
            }, code);
          }
          else {
            this.commonService.ValidationBanner("Error Occured while deleting");

          }
        });
      })
    }

  }
}
